import React from 'react'

const About = ( ) => {
    return (
        <div>
            <h4>Version 1.0.0</h4>
            <a href='/'>Go Back</a>
        </div>
    )
}

export default About
